var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-default cursor-pointer",on:{"click":_vm.goBack}},[_vm._v("\n  Voltar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }